export default __webpack_public_path__ + "static/media/email.287452ba.svg";